import { Component, OnInit, Input } from '@angular/core';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
// import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { RozgarMelaServiceService } from 'projects/services/src/app/API/rozgar-mela-service.service';

@Component({
	selector: 'app-placed-candidates',
	templateUrl: './placed-candidates.component.html',
	styleUrls: ['./placed-candidates.component.css']
})
export class PlacedCandidatesComponent implements OnInit {
	user: any = {};
	perPageNo = 10;
	recordsPerPage = 10;
	pageNo = 1;
	length: any = 0;
	searchBasedOnFields: string[];
	searchText: any;
	@Input() melaDetails: any;
	modelObj: any = {
		userId: '',
		state: '',
		district: '',
		keyword: ''
	}
	melaId: any;
	placedCandidateData: any = [];
	districts: any = [];
	states: any = [];
  constructor(private rozgarMelaService: RozgarMelaServiceService, private currentUserservice: CurrentUserService,
	  private route: ActivatedRoute, private geographiesService: GeographiesService,
  private router: Router) { }

  ngOnInit() {
		this.route.params.subscribe(params => {
			if (params.id) {
				console.log(params);
				this.melaId = params.id;
				this.getPlacedCandi();
			} else {
				this.melaId = this.melaDetails['rozgarMelaId'];
				this.getPlacedCandi();
			}
		});
		this.getState();
		this.getCurrentUser();
  }
  getCurrentUser() {
	// tslint:disable-next-line:one-line
	this.currentUserservice.getCurrentUser().subscribe(loginuser => {
		console.log(loginuser);
		this.user = loginuser;
	});
  }

	viewCandidateDetails(id) {
		this.router.navigate(['view-candidate-details', id], {
			relativeTo: this.route.parent
		});
  }

	setSearchText(searchtext) {
		this.searchText = searchtext;
		this.searchBasedOnFields = ['userName', 'firstName'];
	}

	// 	onPageChange(data) {
	// 	if (this.pageNo !== data) {
	// 		const pagination = this.rozgarMelaService.pagination(this.pageNo, data, this.length, this.candidateArray.length);
	// 		console.log(pagination);
	// 		this.getCandidateDetails(this.participatedCandi.slice(pagination.start, pagination.end));
	// 		this.pageNo = pagination.pageNo
	// 	}
	// }


	onPageChange(data) {
		this.pageNo = data;
		this.getPlacedCandi();
	}

	onRequiredPerPageChage(data) {
		this.perPageNo = data;
		this.getPlacedCandi();
	}

	applyFilters() {
		console.log(this.modelObj);
		this.getPlacedCandi();
	}

	getPlacedCandi() {
		this.rozgarMelaService.getPlacedCandidate(this.recordsPerPage, this.pageNo, this.modelObj, this.melaId).subscribe(pCandidate => {
			this.placedCandidateData = pCandidate.data;
		})
	}

	reset() {
		this.modelObj.userId = '';
		this.getPlacedCandi();
	}

	getState() {
		this.geographiesService.getStates().subscribe(states => {
			const elements = (states.states) || [];
			const mapElements = elements.map(element => ({
				name: element.name,
				value: element.code,
			}));
			Helpers.copyArray(this.states, mapElements);
		});
	}
	onChangeState() {
		this.geographiesService.getDistricts(this.modelObj.state.value).subscribe(districts => {
			const elements = (districts.districts) || [];
			const mapElements = elements.map(element => ({
				name: element.name,
				value: element.code,
			}));
			Helpers.copyArray(this.districts, mapElements);
		});

	}

}
